import React from "react";

import redeGloboImg from "../../../../../../images/icon_channel_globo.png";
import discoveryChannelImg from "../../../../../../images/icon_channel_discovery.svg";
import multishowChannelImg from "../../../../../../images/icon_channel_multishow.svg";
import cartoonNetworkImg from "../../../../../../images/icon_channel_cartoon_network.svg";

import {
  ProductTVImgRedeGloboElement,
  ProductTVImgDiscoveryElement,
  ProductTVImgMultishowElement,
  ProductTVImgCartoonNetworkElement,
} from "../../ProductTVValue.styles";

const ShowImagesPlanMix = () => {
  return (
    <>
      <ProductTVImgRedeGloboElement src={redeGloboImg} alt="" />
      <ProductTVImgDiscoveryElement src={discoveryChannelImg} alt="" />
      <ProductTVImgMultishowElement src={multishowChannelImg} alt="" />
      <ProductTVImgCartoonNetworkElement src={cartoonNetworkImg} alt="" />
    </>
  );
};

export default ShowImagesPlanMix;
